<template>
  <div id="app" class="d-flex flex-column vh-100" data-spy="scroll">
    <Flecha />
    <Header />
    <Section>
      <router-view
        @cargar="cargar"
        @cargado="cargado"
        @onError="atraparError"
        @onAlerta="atraparAlerta"
      ></router-view>
    </Section>
    <Footer />
    <b-modal
      id="modalCargando-1"
      v-model="modalCargando"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
      size="sm"
    >
      <Cargando color="#000000" :tamanio="200" />
    </b-modal>
    <Modal
      ref="modalError"
      tipoModal="ERROR"
      :mensaje="mensajeError"
      :tituloMensaje="tituloError"
      :ayudaMineduc="ayudaMineduc"
      :destino="destinoBotonModalError"
      :textoBoton="textoBotonModalError"
    />
    <Modal
      ref="modalAlerta"
      tipoModal="ALERTA"
      :mensaje="mensajeError"
      :tituloMensaje="tituloError"
      :botoneraDoble="botoneraDoble"
      :ayudaMineduc="ayudaMineduc"
    />
  </div>
</template>

<script>
import Header from "@/components/wrapper/Header";
import Footer from "@/components/wrapper/Footer";
import Cargando from "@/components/generales//modales/Cargando";
import Section from "@/components/wrapper/Section";
import Modal from "@/components/generales/modales/Mensaje";
import Flecha from "@/components/generales/FlechaArriba";
import ProcesaJsonParametros from "@/service/ProcesaJsonParametros";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Cargando,
    Section,
    Modal,
    Flecha
  },
  data() {
    return {
      modalCargando: false,
      modalError: false,
      modalAlerta: false,
      mensajeError: "",
      tituloError: "",
      botoneraDoble: false,
      ayudaMineduc: false,
      destinoBotonModalError: false,
      textoBotonModalError: false
    };
  },
  watch: {
    //Si cambiamos de pagina, cerramos el mensaje de carga
    $route: function() {
      this.modalCargando = false;
    }
  },
  created() {
    const exist = this.$ss.ttl("jwt");
    if (exist > 0) {
      this.$ss.clear();
    }
    this.obtieneParametrosJSON();
  },
  methods: {
    async obtieneParametrosJSON() {
      try {
        const tokenBearer =
          "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNzQ4ODgxNDE0LCJleHAiOjE3ODA0MTc0MTQsImlkUG9zdHVsYWNpb24iOiI2ODNkYmZhODhiYmZmMzAwMDE5YWY1ZmYiLCJpc0FkbWluIjpmYWxzZX0.3AztlB-nsLnr-Pe2-mzyo3gzRaEAowUZq2-VeumajHE";
        const parametrosJSON = await ProcesaJsonParametros.obtenerInformacion(
          this,
          tokenBearer
        );
        if (parametrosJSON.C_periodoListaEsperaResultado) {
          localStorage.setItem(
            "C_periodoListaEsperaResultado",
            parametrosJSON.C_periodoListaEsperaResultado
          );
          localStorage.setItem(
            "C_periodoRegularizacion",
            parametrosJSON.C_periodoRegularizacion
          );
          localStorage.setItem(
            "C_fechaLimiteModificacionPostulacion",
            parametrosJSON.C_fechaLimiteModificacionPostulacion
          );
          localStorage.setItem(
            "C_fechaPublicacionResultadoComplementario",
            parametrosJSON.C_fechaPublicacionResultadoComplementario
          );
          localStorage.setItem("C_anioEscolar", parametrosJSON.C_anioEscolar);
          localStorage.setItem(
            "C_mostrarMatriculaAsegurada",
            parametrosJSON.C_mostrarMatriculaAsegurada
          );
          localStorage.setItem(
            "C_periodoComplementario",
            parametrosJSON.C_periodoComplementario
          );
          localStorage.setItem(
            "C_terminoEtapa1Resultados",
            parametrosJSON.C_terminoEtapa1Resultados
          );
          localStorage.setItem(
            "C_fechaFinPostulacion",
            parametrosJSON.C_fechaFinPostulacion
          );
          localStorage.setItem(
            "C_fechaResultados",
            parametrosJSON.C_fechaResultados
          );
          localStorage.setItem(
            "C_periodoMatricula",
            parametrosJSON.C_periodoMatricula
          );
        } else {
          console.error("Error al procesar datos de JSON.");
        }
      } catch (error) {
        console.error("Error al procesar datos de JSON.", error);
      }
    },

    handleScroll: function() {
      window.scrollY > 0
        ? (document.getElementById("myBtn").style.display = "block")(
            (document.getElementById("flecha-abajo").style.display = "none")
          )
        : (document.getElementById("myBtn").style.display = "none");
      document.getElementById("flecha-abajo").style.display = "none";
    },
    //atrapa error y muestra modal con informacion correspondiente
    atraparError(mensaje, titulo, ayuda, destino, textoDestino) {
      this.tituloError = titulo ? titulo : "Error";
      this.mensajeError = mensaje;
      if (ayuda) {
        this.ayudaMineduc = true;
      }
      if (destino) {
        this.destinoBotonModalError = destino;
        this.textoBotonModalError = textoDestino;
      }
      this.$refs.modalError.showModal();
    },
    atraparAlerta(mensaje, titulo, tipoBotonera, ayuda) {
      this.botoneraDoble = false;
      this.ayudaMineduc = false;
      this.tituloError = titulo ? titulo : "Alerta";
      this.mensajeError = mensaje;
      if (tipoBotonera) {
        this.botoneraDoble = true;
      }
      if (ayuda) {
        this.ayudaMineduc = true;
      }
      this.$refs.modalAlerta.showModal();
    },
    //muestra modal cargando
    cargar() {
      this.modalCargando = true;
    },
    //quita modal de cargando
    cargado() {
      this.modalCargando = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue